import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort",
  "use": "sort-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"sort\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\"><path d=\"M17.288 25.031l-3.644 3.644L10 25.03m3.644 3.644l-.22-18.364m8.089 6.576L24.733 10l3.22 6.887m-5.345-2.07h4.38\" /><path stroke-linejoin=\"round\" d=\"M21.513 21.478h6.122l-5.122 6.876h6.031\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol